import { create } from 'zustand';
import type { CertificationSummaryOut } from '../types';

const STORAGE_KEY = 'cloudmaster_certification';
const DEFAULT_CERT = 'az-104';

interface CertState {
  certCode: string;
  certName: string;
  providerCode: string;
  providerName: string;
  providerColor: string;
  isLoading: boolean;
  /** Cached list of certifications from API, used by setCertification. */
  _certifications: CertificationSummaryOut[];

  setCertification: (code: string) => void;
  initFromApi: (certifications: CertificationSummaryOut[]) => void;
}

/** Read persisted certification code from localStorage, default to az-104. */
function getInitialCertCode(): string {
  return localStorage.getItem(STORAGE_KEY) || DEFAULT_CERT;
}

export const useCertStore = create<CertState>((set, get) => ({
  certCode: getInitialCertCode(),
  certName: '',
  providerCode: '',
  providerName: '',
  providerColor: '#0078D4',
  isLoading: true,
  _certifications: [],

  setCertification: (code: string) => {
    const certs = get()._certifications;
    const cert = certs.find((c) => c.code === code);
    if (!cert) return;

    localStorage.setItem(STORAGE_KEY, code);
    set({
      certCode: cert.code,
      certName: cert.name,
      providerCode: cert.provider.code,
      providerName: cert.provider.name,
      providerColor: cert.provider.color,
    });
  },

  initFromApi: (certifications: CertificationSummaryOut[]) => {
    const currentCode = get().certCode;
    const cert =
      certifications.find((c) => c.code === currentCode) ||
      certifications[0];

    if (!cert) {
      set({ isLoading: false, _certifications: certifications });
      return;
    }

    localStorage.setItem(STORAGE_KEY, cert.code);
    set({
      certCode: cert.code,
      certName: cert.name,
      providerCode: cert.provider.code,
      providerName: cert.provider.name,
      providerColor: cert.provider.color,
      isLoading: false,
      _certifications: certifications,
    });
  },
}));
